<template>
  <div>
    <v-layout wrap justify-center class="fontts">
      <v-flex xs12 lg11 py-10 align-self-center>
        <v-card>
          <v-layout wrap justify-center text-center>
            <v-flex lg11 py-4 align-self-center class="heading-decorate text-uppercase">
              <span style="font-family:poppins-semibold ;font-size:20px ">Sightings Location</span>
              <!-- {{ location[0] }}
              {{ location[1] }} -->
            </v-flex>
          </v-layout>
          <div id="mapnew6"></div>
          <!-- <GmapMap
            :center="{ lat: lat, lng: lon }"
            :zoom="8"
            map-type-id="terrain"
            style="width: 100%; height: 520px"
          >
            <GmapMarker
                  :position="{ lat: lat, lng: lon }"
                  :clickable="true"
                  :draggable="false"
                />
            />
          </GmapMap> -->
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script
  src="https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyCaccNxbzwR9tMvkppT7bT7zNKjChc_yAw&libraries=visualization,drawing">
</script>
<script>
import axios from "axios";

export default {
  data() {
    return {
      lat: 0,
      lon: 0,
      map3: null,
      marker: [],
    };
  },
  props: ["id"],
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      // this.map3 = new google.maps.Map(document.getElementById("mapnew6"), {
      //   zoom: 4,
      //   center: { lat: 12.38, lng: 80.12 },
      //   // center: { lat: 9.528339, lng: 76.822503 },
      //   mapTypeId: "terrain",
      // });
      this.marker = new google.maps.Marker({
        // position: { lat: this.latt, lng: this.lonn },
        map: this.map3,
        title: "Hello World!",
      });
      axios({
        method: "GET",
        url: "report/get", 
        params: {'id':this.id},

        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      }).then((response) => {
        if(response.data.status) {
          this.lat=response.data.data.location[1]
          this.lon=response.data.data.location[0]
          
          this.map3 = new google.maps.Map(document.getElementById("mapnew6"), {
        zoom: 8,
        center: { lat: this.lat, lng: this.lon },
        // center: { lat: 9.528339, lng: 76.822503 },
        mapTypeId: "terrain",
      });
          this.marker = new google.maps.Marker({
                position: { lat: this.lat, lng: this.lon },
                map: this.map3,
                icon: this.icons,
                title: "Hello World!",
              });
        }
      })
    },
  },
};
</script>

<style>
#mapnew6 {
  height: 600px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>